import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";

const FAQ = () => {
  const { t } = useLanguage();
  const items = t.faq.items;

  return (
    <section id="faq" className="relative py-24 lg:py-36 bg-anthracite text-cream">
      <div className="container-boe grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-4">
          <span className="section-eyebrow">{t.faq.eyebrow}</span>
          <h2 className="mt-5 text-4xl md:text-5xl lg:text-6xl font-semibold text-cream leading-[1.05] tracking-tight">
            {t.faq.title}
          </h2>
          <div className="mt-10 ornate-divider hidden lg:flex" />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-8"
        >
          <Accordion type="single" collapsible className="w-full">
            {items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-cream/15 last:border-b-0"
              >
                <AccordionTrigger className="py-6 text-left text-lg md:text-xl font-medium text-cream hover:text-gold-soft hover:no-underline">
                  <span className="flex items-baseline gap-4">
                    <span className="font-accent italic text-xl" style={{ color: "#E5C76B" }}>0{i + 1}</span>
                    {item.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base text-cream/75 leading-relaxed pl-10">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
